import { faExternalLink } from '@fortawesome/pro-regular-svg-icons';
import PropTypes from 'prop-types';

import { Icon } from 'Icons';

const LinkNewWindow = ({ children, href, iconAlt, ...rest }) => (
  <a href={href} rel="noopener noreferrer" target="_blank" {...rest}>
    {children} <Icon alt={iconAlt} icon={faExternalLink} />
  </a>
);

LinkNewWindow.defaultProps = {
  iconAlt: 'Open in new window',
};

LinkNewWindow.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  iconAlt: PropTypes.string,
};

export default LinkNewWindow;
